<template>
  <div>
    <el-transfer
      v-model="bindUsers"
      :data="unbindUsers"
      filterable
      :titles="['待选列表', '选中列表']"
      :filter-method="filterUser"
      target-order="unshift"
      @change="onTransferChanged"
      :props="{
      key: 'id',
      label: 'name'
    }"
      v-if="bindUsers.length > 0||unbindUsers.length>0"
      style="margin-top:20px"
    ></el-transfer>
  </div>
</template>

<script>
export default {
  name: "PersonCascader",
  data() {
    return {
      bindUsers: [],
      unbindUsers: []
    }
  },
  methods:{
    initPersons(ids,names){
      let persons = new Array();
      for(let i = 0 ; i < ids.length; i++){
        let data = {
          id: ids[i],
          name: names[i]
        }

        persons.push(data);
      }
      this.bindUsers = ids;
      this.unbindUsers = persons;
    },

    initData(datas){
      this.bindUsers = datas;
    },


    initunbindUsers(datas){
      this.unbindUsers = this.unbindUsers.concat(datas);
    },

    initbindUsers(datas){
      this.bindUsers = datas;
    },

    // 穿梭框的筛选
    filterUser(query, item) {
      return item.name.indexOf(query) > -1;
    },

    // extend
    onValueChanged() {
      this.$emit("onValueChanged", this.bindUsers);
    },

    onTransferChanged(){
      this.onValueChanged();
    }
  },
  mounted(){

  }
}


// @Watch("unbindUsers")
//   onUnBindUsers() {
//     let removeRepeat: string[] = [];
//     for (let i = 0; i < this.unbindUsers.length; i++) {
//       let item = this.unbindUsers[i].id;
//       if (removeRepeat.indexOf(item) == -1) {
//         removeRepeat.push(item);
//       } else {
//         this.unbindUsers.splice(i, 1);
//       }
//     }
//   }

</script>





<style>
</style>